import { IFileDesc, IUploadFile, IStuffBeingUploaded, IFinishedUpload } from '@app-types/websocket/file.types';
import { createAction } from 'redux-act';

export const requestFileUpload = createAction<IUploadFile>('Request File upload');

export const requestChatFileUploadSlot = createAction<IUploadFile>('Request chat File upload slot');

export const removeStoredFile = createAction<number>('removed stored file'); // this should remove the file from the bucket

export const uploadProgress = createAction<IStuffBeingUploaded>('upload progress percentage');

export const uploadSuccess = createAction<IStuffBeingUploaded>('upload finished');

export const uploadFailed = createAction<IStuffBeingUploaded>('upload failed');

export const uploadSlotRejected = createAction<{internalId:number; errorMessage:string}>('upload slot rejected');

export const uploadedFileUsed = createAction<number>('uploaded file used'); // this will remove the file locally

export const suppressLoadingScreenForFilePickerUntil = createAction<number>('Suppress loading screen for file picker until');

export const storeFileWhileAwaitingUploadslot = createAction<IUploadFile>('store File while awaiting upload slot'); // this is called internally

export const internalUploadFileAfterGivenSlot = createAction<IStuffBeingUploaded>('upload file to bucket'); // this is called internally



// WEBPACK FOOTER //
// ./src/services/file/file.actions.ts